import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let lastRoute = null;
let currentRoute = null;

export const getLastRoute = () => lastRoute;

export const useRouteTracker = () => {
  return { lastRoute, currentRoute };
};

export const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (currentRoute !== location.pathname) {
      lastRoute = currentRoute;
      currentRoute = location.pathname;
      // console.log("Last:", lastRoute, "Current:", currentRoute);
    }
  }, [location]);

  return null;
};
